import { c as _c } from "react/compiler-runtime";
import type { DonationBusinessesApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { ROUTES } from '@/constants';
import { SearchDonationCard } from '../DonationBusinessSearch/SearchDonationCard';
import { SearchDonationSkeletonList } from '../DonationBusinessSearch/SearchDonationCardSkeleton';
import { SectionHeader } from './SectionHeader';
const PREVIEW_COUNT = 3;
export function DonationBusinessPreviewSection(t0) {
  const $ = _c(11);
  const {
    keyword,
    items,
    totalCount,
    isLoading
  } = t0;
  if (!isLoading && items.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== keyword) {
    t1 = ROUTES.SEARCH.withSearchParams({
      searchParams: {
        q: keyword || undefined,
        category: "hometown-business"
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalCount) {
    t2 = <SectionHeader title={"\uC9C0\uC815\uAE30\uBD80\uC0AC\uC5C5"} totalCount={totalCount} moreHref={t1} />;
    $[2] = t1;
    $[3] = totalCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isLoading || $[6] !== items) {
    t3 = isLoading ? <SearchDonationSkeletonList count={PREVIEW_COUNT} /> : <ul className="flex flex-col gap-20 mobile-tablet:gap-16 mobile-tablet:px-20">{items.map((item, idx) => <Fragment key={item.donationBusinessId}><SearchCategoryAdSlot as="li" placement="search-all-donation-business" position={idx + 1} listLength={items.length} className="mx-auto" /><li><SearchDonationCard businessId={item.donationBusinessId ?? 0} thumbnailUrl={item.thumbnailUrl ?? ""} title={item.donationBusinessName ?? ""} institutionName={item.institutionName ?? ""} endDate={item.endDate} donationAmount={Math.max((item.goalAmt ?? 0) - (item.rmAmt ?? 0), 0)} achievementRate={item.achievementRate ?? 0} isEnded={item.specificDonationStatus === "ENDED"} /></li></Fragment>)}</ul>;
    $[5] = isLoading;
    $[6] = items;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <section className="flex w-full flex-col">{t2}{t3}</section>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}